import { render } from "./FullscreenOverlay.vue?vue&type=template&id=7712e788"
import script from "./FullscreenOverlay.vue?vue&type=script&lang=js"
export * from "./FullscreenOverlay.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__